(function() {

const USE_GREEN_MARK = true;
const SPIXN_BASE_COLOR = '#4A2D57'; // 元のもの: #6C30CF
const SPIXN_GREEN = '#158E7A';
const SPIXN_GREEN2 = '#31727A';
const SPIXN_GREEN3 = '#02968A';
const SPIXN_GREEN_FOR_MARK = '#17A089';
const SPIXN_GREEN_FOR_CHECK = '#1AB298';
const SPIXN_LIGHT_GREEN = '#E8F7F5';
const SPIXN_BUTTON_ACTIVE_BACKGROUND = 'linear-gradient(73deg,rgba(2, 188, 172, 1) 0%, rgba(75, 73, 101, 1) 100%)';
const SPIXN_BUTTON_INACTIVE_BACKGROUND = 'white';
const SPIXN_BUTTON_ACTIVE_COLOR = 'white';
const SPIXN_BUTTON_INACTIVE_COLOR = SPIXN_GREEN;


const BUYBACK_MODAL_SHOW_PRICE_RANGE = false; // true: 価格帯を表示する, false: 価格帯を表示しない
const SHOW_BUYBACK_PRICE_AS_PERCENTAGE = false; // true: バイバック保証額を販売額の%で表示, false: バイバック保証額をそのまま表示

const MODAL_CONTAINER_SELECTOR = 'quick-view-drawer details';



// --- 先頭に追加 ---
// const CART_DISPLAY_MODE = 'redirect'; // debug: デバッグ用（リダイレクトなし）, drawer: ドロワー表示, redirect: カートページリダイレクト
const CART_DISPLAY_MODE = 'drawer'; // debug: デバッグ用（リダイレクトなし）, drawer: ドロワー表示, redirect: カートページリダイレクト

let DEBUG_MODE = true; // true: デバッグモード, false: 通常モード（本番環境ではfalse）
let log = DEBUG_MODE
	? console.log
	: () => {
			/* no-op */
		};

const BUYBACK_TOGGLE_BUTTON_INACTIVE_FONT_COLOR = '#26202C'; // default black
const SPIXN_BASE_FONT_SIZE = 24.8; // カスタムベースフォントサイズ（通常16pxより大きく設定）
const FONT_SIZE_RATIO = SPIXN_BASE_FONT_SIZE / 16;
const BASE_FONT_FAMILY = '"Libre Baskerville", serif';




// ヘルパー関数：rem値をスケールされたcalc()に変換
function calcSize(size, option) {
	return `calc(${size} * ${FONT_SIZE_RATIO}${option ? option : ''})`;
}

// === API関連の設定と関数 ===
let API_BASE_URL = 'https://ieyxoq7t4c.execute-api.ap-northeast-1.amazonaws.com/dev';
const API_TIMEOUT = 10000; // 10秒
const DEFAULT_HEADERS = {
	'Content-Type': 'application/json',
	'Accept': 'application/json'
};

// SPIXN API設定オブジェクト
const SPIXN_CONFIG = {
	USE_API: true,                    // API使用フラグ
	ENABLE_CACHE: true,               // キャッシュ使用フラグ
	FALLBACK_TO_LOCAL: false,         // ローカルデータフォールバック（常にfalse）
	DEBUG_MODE: false,                // デバッグモード
	API_TIMEOUT: 10000,               // APIタイムアウト（ミリ秒）
	CACHE_TTL: 5 * 60 * 1000,        // キャッシュTTL（5分）
	MAX_RETRIES: 3,                   // 最大リトライ回数
	RETRY_DELAY: 1000,                // リトライ遅延（ミリ秒）
	BATCH_SIZE: 10                    // バッチ処理サイズ
};

// Shop ID管理用のグローバル変数
let SHOP_ID = null;

/**
 * API Base URLを取得
 * @returns {string} API Base URL
 */
function getApiBaseUrl() {
	return API_BASE_URL;
}

/**
 * API Base URLを設定
 * @param {string} baseUrl - API Base URL
 */
function setApiBaseUrl(baseUrl) {
	if (baseUrl && typeof baseUrl === 'string') {
		API_BASE_URL = baseUrl;
		log('[SPIXN Modal] API Base URL set:', baseUrl);
	}
}

/**
 * Shop IDを取得
 * @returns {string|null} Shop ID
 */
function getShopId() { 
	return SHOP_ID; 
}

/**
 * Shop IDを設定
 * @param {string} shopId - Shop ID
 */
function setShopId(shopId) { 
	SHOP_ID = shopId; 
}

/**
 * Shop IDの形式を検証
 * @param {string} shopId - Shop ID
 * @returns {boolean} 検証結果
 */
function validateShopId(shopId) {
	if (!shopId || typeof shopId !== 'string') {
		return false;
	}
	
	// .myshopify.com形式のチェック
	const shopifyDomainPattern = /^[a-zA-Z0-9\-]+\.myshopify\.com$/;
	return shopifyDomainPattern.test(shopId);
}

/**
 * 共通API呼び出し関数
 * @param {string} endpoint - APIエンドポイント
 * @param {Object} params - クエリパラメータ
 * @param {Object} options - 追加オプション
 * @returns {Promise<Object>} APIレスポンス
 */
async function callSpixnAPI(endpoint, params = {}, options = {}) {
	const controller = new AbortController();
	const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT);

	try {
		const url = new URL(`${API_BASE_URL}${endpoint}`);
		
		// パラメータをクエリストリングに追加
		Object.keys(params).forEach(key => {
			if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
				url.searchParams.append(key, params[key]);
			}
		});

		log('[SPIXN Modal] API call:', url.toString());

		const response = await fetch(url.toString(), {
			method: 'GET',
			headers: {
				...DEFAULT_HEADERS,
				...options.headers
			},
			signal: controller.signal
		});

		clearTimeout(timeoutId);

		if (!response.ok) {
			throw new Error(`API call failed: ${response.status} ${response.statusText}`);
		}

		const data = await response.json();
		log('[SPIXN Modal] API response:', data);
		
		return data;
	} catch (error) {
		clearTimeout(timeoutId);
		
		if (error.name === 'AbortError') {
			throw new Error('API call timeout');
		}
		
		console.error('[SPIXN Modal] API call error:', error);
		throw error;
	}
}

/**
 * リトライ可能なエラーかどうかを判定
 * @param {Error} error - エラーオブジェクト
 * @returns {boolean} リトライ可能かどうか
 */
function isRetryableError(error) {
	// ネットワークエラーやタイムアウトはリトライ可能
	if (error.name === 'AbortError' || error.message.includes('timeout')) {
		return true;
	}
	
	// 5xx系エラーはリトライ可能
	if (error.message.includes('50')) {
		return true;
	}
	
	// 4xx系エラーはリトライしない
	return false;
}

/**
 * リトライ機能付きAPI呼び出し関数
 * @param {string} endpoint - APIエンドポイント
 * @param {Object} params - クエリパラメータ
 * @param {Object} options - 追加オプション
 * @returns {Promise<Object>} APIレスポンス
 */
async function callSpixnAPIWithRetry(endpoint, params = {}, options = {}) {
	const maxRetries = options.maxRetries || SPIXN_CONFIG.MAX_RETRIES;
	const retryDelay = options.retryDelay || SPIXN_CONFIG.RETRY_DELAY;

	for (let attempt = 1; attempt <= maxRetries; attempt++) {
		try {
			return await callSpixnAPI(endpoint, params, options);
		} catch (error) {
			if (attempt === maxRetries) {
				throw error;
			}

			// リトライ可能なエラーかチェック
			if (isRetryableError(error)) {
				log(`[SPIXN Modal] API call failed (attempt ${attempt}/${maxRetries}), retrying...`);
				await new Promise(resolve => setTimeout(resolve, retryDelay * attempt));
			} else {
				throw error;
			}
		}
	}
}

/**
 * 数値IDをShopify GID形式に変換
 * @param {string|number} id - 数値ID
 * @param {string} type - リソースタイプ（'Product' または 'ProductVariant'）
 * @returns {string} GID形式のID
 */
function convertToShopifyGID(id, type) {
	if (!id) return null;
	const numericId = id.toString();
	return `gid://shopify/${type}/${numericId}`;
}

/**
 * Shopify GIDから数値IDを抽出
 * @param {string} gid - GID形式のID
 * @returns {string|null} 数値ID
 */
function extractNumericIdFromGID(gid) {
	if (!gid || typeof gid !== 'string') return null;
	const match = gid.match(/gid:\/\/shopify\/\w+\/(\d+)/);
	return match ? match[1] : null;
}

/**
 * 現在の商品IDを取得（GID形式で返す）
 * @returns {string|null} 商品ID（GID形式）
 */
function getCurrentProductId() {
	const variantInput = document.querySelector('quick-view-drawer details.menu-opening product-form form input[name="product-id"]');
	log('Current variant input:', variantInput);
	return variantInput ? parseInt(variantInput.value, 10) : null;


	// try {
	// 	// モーダル内の場合は、モーダル内の要素から取得
	// 	const modal = document.querySelector('quick-add-modal[open]');
	// 	if (modal) {
	// 		// 方法1: モーダル内のdata属性から取得
	// 		const productElement = modal.querySelector('[data-product-id]');
	// 		if (productElement) {
	// 			const productId = productElement.getAttribute('data-product-id');
	// 			if (productId) {
	// 				log('[SPIXN Modal] Product ID found in modal data attribute:', productId);
	// 				return convertToShopifyGID(productId, 'Product');
	// 			}
	// 		}

	// 		// 方法2: モーダル内のフォームから取得
	// 		const form = modal.querySelector('form.form');
	// 		if (form) {
	// 			const productIdInput = form.querySelector('input[name="product-id"]');
	// 			if (productIdInput?.value) {
	// 				log('[SPIXN Modal] Product ID found in modal form:', productIdInput.value);
	// 				return convertToShopifyGID(productIdInput.value, 'Product');
	// 			}
	// 		}

	// 		// 方法3: モーダル内のvariant inputから商品IDを推測
	// 		const variantInput = modal.querySelector('input[name="id"].product-variant-id');
	// 		if (variantInput?.value) {
	// 			// バリアントIDから商品IDを取得するため、APIを使用する必要がある
	// 			// 一時的にvariantIDをログ出力
	// 			log('[SPIXN Modal] Variant ID found in modal, need to derive product ID:', variantInput.value);
	// 		}
	// 	}

	// 	// 通常のページでの取得方法
	// 	// 方法1: ShopifyAnalyticsから取得
	// 	const productData = window.ShopifyAnalytics?.meta?.product;
	// 	if (productData?.id) {
	// 		const numericId = productData.id.toString();
	// 		log('[SPIXN Modal] Product ID found in ShopifyAnalytics:', numericId);
	// 		return convertToShopifyGID(numericId, 'Product');
	// 	}

	// 	// 方法2: フォームのhidden inputから取得
	// 	const productIdInput = document.querySelector('input[name="product-id"]');
	// 	if (productIdInput?.value) {
	// 		log('[SPIXN Modal] Product ID found in form input:', productIdInput.value);
	// 		return convertToShopifyGID(productIdInput.value, 'Product');
	// 	}

	// 	// 方法3: data属性から取得
	// 	const productElement = document.querySelector('[data-product-id]');
	// 	if (productElement) {
	// 		const productId = productElement.getAttribute('data-product-id');
	// 		if (productId) {
	// 			log('[SPIXN Modal] Product ID found in data attribute:', productId);
	// 			return convertToShopifyGID(productId, 'Product');
	// 		}
	// 	}

	// 	// 方法4: URLから商品ハンドルを取得（最後の手段）
	// 	const pathMatch = window.location.pathname.match(/\/products\/([^\/]+)/);
	// 	if (pathMatch) {
	// 		const handle = pathMatch[1];
	// 		// ハンドルから商品IDを取得する処理が必要
	// 		// この部分は環境に依存するため、実装時に調整が必要
	// 		console.warn('[SPIXN Modal] Product ID not found, handle detected:', handle);
	// 	}

	// 	console.error('[SPIXN Modal] Product ID not found');
	// 	return null;
	// } catch (error) {
	// 	console.error('[SPIXN Modal] Failed to get product ID:', error);
	// 	return null;
	// }
}

/**
 * APIレスポンスを既存形式に変換
 * @param {Object} buybackData - APIレスポンスデータ
 * @returns {Object} 変換されたバイバック情報
 */
function transformBuybackData(buybackData) {
	return {
		buyback_variant_id: parseInt(buybackData.buyback_sp_variant_id),
		insurance_period_days: buybackData.insurance_period_days,
		insurance_fee: buybackData?.insurance_fee || 0,
		plans: [{
			plan: 'default',
			insurance_period_days: buybackData.insurance_period_days,
			a_price: buybackData.a_price,
			b_price: buybackData.b_price,
			c_price: buybackData.c_price,
			a_min_price: buybackData.a_min_price || Math.round(buybackData.a_price * 0.85),
			a_max_price: buybackData.a_max_price || Math.round(buybackData.a_price * 1.15),
			b_min_price: buybackData.b_min_price || Math.round(buybackData.b_price * 0.85),
			b_max_price: buybackData.b_max_price || Math.round(buybackData.b_price * 1.15),
			c_min_price: buybackData.c_min_price || Math.round(buybackData.c_price * 0.85),
			c_max_price: buybackData.c_max_price || Math.round(buybackData.c_price * 1.15),
			a_price_ratio: buybackData.a_price_ratio,
			b_price_ratio: buybackData.b_price_ratio,
			c_price_ratio: buybackData.c_price_ratio,
			a_min_price_ratio: buybackData.a_min_price_ratio || buybackData.a_price_ratio * 0.85,
			a_max_price_ratio: buybackData.a_max_price_ratio || buybackData.a_price_ratio * 1.15,
			b_min_price_ratio: buybackData.b_min_price_ratio || buybackData.b_price_ratio * 0.85,
			b_max_price_ratio: buybackData.b_max_price_ratio || buybackData.b_price_ratio * 1.15,
			c_min_price_ratio: buybackData.c_min_price_ratio || buybackData.c_price_ratio * 0.85,
			c_max_price_ratio: buybackData.c_max_price_ratio || buybackData.c_price_ratio * 1.15
		}]
	};
}

/**
 * バイバックデータの検証
 * @param {Object} data - 検証対象データ
 * @returns {boolean} 検証結果
 */
function validateBuybackData(data) {
	const requiredFields = [
		'sp_shop_id',
		'sp_product_id',
		'sp_variant_id',
		'buyback_sp_variant_id',
		'insurance_fee',
		'insurance_period_days',
		'a_price',
		'b_price',
		'c_price',
		'a_price_ratio',
		'b_price_ratio',
		'c_price_ratio'
	];

	for (const field of requiredFields) {
		if (data[field] === null || data[field] === undefined) {
			console.error(`[SPIXN Modal] Missing required field: ${field}`);
			return false;
		}
	}

	// 数値フィールドの検証
	const numericFields = [
		'insurance_fee',
		'insurance_period_days',
		'a_price',
		'b_price',
		'c_price',
		'a_price_ratio',
		'b_price_ratio',
		'c_price_ratio'
	];

	for (const field of numericFields) {
		if (typeof data[field] !== 'number' || data[field] < 0) {
			console.error(`[SPIXN Modal] Invalid numeric field: ${field} = ${data[field]}`);
			return false;
		}
	}

	return true;
}

/**
 * バイバック情報を取得（API版）
 * @param {number|string} variantId - バリアントID
 * @returns {Promise<Object|null>} バイバック情報
 */
async function getBuybackInformation(variantId) {
	try {
		// Shop IDチェック（セットされていなければ何もしない）
		const shopId = getShopId();
		if (!shopId) {
			log('[SPIXN Modal] Shop ID not set, skipping buyback information retrieval');
			return null;
		}

		let productId = getCurrentProductId();
		
		// 商品IDが取得できない場合、バリアントIDから推測を試みる
		if (!productId && variantId) {
			log('[SPIXN Modal] Product ID not found, attempting to derive from variant ID:', variantId);
			// バリアントIDをGID形式に変換してAPIに渡す
			const variantGID = convertToShopifyGID(variantId, 'ProductVariant');
			
			// APIパラメータを構築（商品IDなしでバリアントIDのみ）
			const params = {
				sp_shop_id: shopId,
				sp_variant_id: variantGID
			};

			// API呼び出し
			const response = await callSpixnAPIWithRetry('/shopify/buyback', params);

			// レスポンス検証
			if (!response.data || !Array.isArray(response.data) || response.data.length === 0) {
				log('[SPIXN Modal] No buyback information found for variant:', variantId);
				return null;
			}

			const buybackData = response.data[0];
			
			// データ検証
			if (!validateBuybackData(buybackData)) {
				throw new Error('Invalid buyback data received from API');
			}

			// 既存の形式に変換
			return transformBuybackData(buybackData);
		}

		if (!productId) {
			throw new Error('Product ID not available and cannot derive from variant ID');
		}

		// APIパラメータを構築
		const params = {
			sp_shop_id: shopId,
			sp_product_id: productId.toString()
		};

		// バリアントIDが指定されている場合は追加
		if (variantId) {
			params.sp_variant_id = convertToShopifyGID(variantId, 'ProductVariant');
		}

		// API呼び出し
		const response = await callSpixnAPIWithRetry('/shopify/buyback', params);

		// レスポンス検証
		if (!response.data || !Array.isArray(response.data) || response.data.length === 0) {
			log('[SPIXN Modal] No buyback information found for variant:', variantId);
			return null;
		}

		const buybackData = response.data[0];
		
		// データ検証
		if (!validateBuybackData(buybackData)) {
			throw new Error('Invalid buyback data received from API');
		}

		// 既存の形式に変換
		return transformBuybackData(buybackData);
	} catch (error) {
		console.error('[SPIXN Modal] Failed to get buyback information:', error);
		return null;
	}
}

/**
 * SPIXN API機能の初期化
//  */
// async function initializeSpixnAPI() {
// 	try {
// 		log('[SPIXN Modal] Initializing SPIXN API...');
		
// 		// Shop IDを自動取得して設定
// 		const shopId = window.Shopify?.shop;
// 		if (shopId && validateShopId(shopId)) {
// 			setShopId(shopId);
// 			log('[SPIXN Modal] Shop ID set automatically:', shopId);
// 		} else {
// 			console.warn('[SPIXN Modal] Shop ID not available or invalid:', shopId);
// 		}
		
// 		log('[SPIXN Modal] SPIXN API initialization completed');
// 		return true;
// 	} catch (error) {
// 		console.error('[SPIXN Modal] SPIXN API initialization failed:', error);
// 		return false;
// 	}
// }

let isModalVisible = false;
let buybackToggleEnabled = false;
let modalStylesAdded = false;

function toggleAcceleratedCheckoutBlock(isBuybackEnabled) {
  const payContainer = document.querySelector('.shopify-payment-button');
  payContainer.style.position = 'relative'; // 確実に relative にする
  if (!payContainer) return;

  // 既に付いているブロッカーを消す
  const existing = payContainer.querySelector('.spixn-pay-blocker');
  if (existing) existing.remove();

  // モード ON のときだけ blocker を追加
  if (isBuybackEnabled) {
    const blocker = document.createElement('div');
	Object.assign(blocker.style, {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(255,255,255,0.5)",
      zIndex: 50,
	  display: "block",
	});

    blocker.className = 'spixn-pay-blocker';
    payContainer.appendChild(blocker);
	
	log('Accelerated checkout block enabled', blocker, payContainer);
  }
}

// ダイアログ内のpタグのmarginを0にするスタイルを追加
function addModalStyles() {
	if (modalStylesAdded) return;
	
	const style = document.createElement('style');
	style.textContent = `
		#spixn-buyback-modal p {
			margin: 0;
		}
		#spixn-buyback-modal button {
		   font-family: ${BASE_FONT_FAMILY};
        }
	`;
	document.head.appendChild(style);
	modalStylesAdded = true;
}

// document.addEventListener('DOMContentLoaded', function() {
//   // API初期化を先に実行
//   initializeSpixnAPI().then(() => {
//     // モーダル監視の初期化
//     initializeModalObserver();
//   });
// });

function initializeModalObserver() {
  function attachModalObserver(modal) {
    if (modal.__spixnObs) return;
    modal.__spixnObs = true;
    const modalObserver = new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.type === 'attributes' && m.attributeName === 'open' && m.target.hasAttribute('open')) {
          const info = m.target.querySelector('.quick-view__content');
          if (info && !info.querySelector('#spixn-custom-ui')) {
			const custom = document.createElement('span');
			custom.style.display = 'none';
            custom.id = 'spixn-custom-ui';
            custom.innerHTML = `<p>spixn UI</p>`;
            info.appendChild(custom);
			log('Modal opened, setting up Spixn UI:', info);
			log("set up buyback integration after 100ms delay to ensure DOM is ready");
			setTimeout(() => {
				setupBuybackIntegration();
				// バリエーション変更を監視（MutationObserverを使用）
				setupVariantChangeObserver();
			}, 100);

          }
        }
      });
    });
    modalObserver.observe(modal, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  // ① 既存のモーダルがあればセット
//   document.querySelectorAll(MODAL_CONTAINER_SELECTOR).forEach(attachModalObserver);

  // ② 新規挿入されたモーダルをキャッチ
  const bodyObserver = new MutationObserver(muts => {
    muts.forEach(m => {
      if (m.type === 'childList' && m.addedNodes.length) {
        m.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
		  log('Node added to body:', node);
        //   if (node.matches('.quick-view__right.product__info-wrapper product-form form input[name="id"]')) {
	   	  if (node.matches('.quick-view__right.product__info-wrapper more-payment-options-link')) {
			const modal = node.closest(MODAL_CONTAINER_SELECTOR);
			if(!modal) return;
			log('New modal detected, attaching observer:', modal);
            // attachModalObserver(modal);

			const info = modal.querySelector('.quick-view__content');
			log('Checking modal content for Spixn UI:', info);
			if (info && !info.querySelector('#spixn-custom-ui')) {
				const custom = document.createElement('span');
				custom.style.display = 'none';
				custom.id = 'spixn-custom-ui';
				custom.innerHTML = `<p>spixn UI</p>`;
				info.appendChild(custom);
				log('Modal opened, setting up Spixn UI:', info);
				log("set up buyback integration after 100ms delay to ensure DOM is ready");
				setTimeout(() => {
					setupBuybackIntegration();
					// バリエーション変更を監視（MutationObserverを使用）
					setupVariantChangeObserver();
				}, 100);

			}

          }
        //   node.querySelectorAll &&
        //     node.querySelectorAll('quick-add-modal').forEach(attachModalObserver);
        });
      }
    });
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
}

async function setupBuybackIntegration() {
	log('setupBuybackIntegration');
	
	const currentVariantId = getCurrentVariantId();
	if (!currentVariantId) {
		log('Current variant ID not found');
		return;
	}

	const buybackInfo = await getBuybackInformation(currentVariantId);
	if (!buybackInfo) {
		log('No buyback information found for variant:', currentVariantId);
		return;
	}

	// 既存のボタンを取得
	const originalButton = document.querySelector('quick-view-drawer details.menu-opening product-form form .product-form__buttons button[name="add"]');
	if (!originalButton) {
		log('Original submit button not found');
		return;
	}

	// バイバック保証UIを設置
	setupBuybackUI(buybackInfo, originalButton);
	
	// 既存ボタンの動作を変更
	modifyOriginalButton(originalButton, buybackInfo);
}

async function updateBuybackUIForVariant() {
	log('updateBuybackUIForVariant');
	
	const currentVariantId = getCurrentVariantId();
	if (!currentVariantId) {
		log('Current variant ID not found for update');
		return;
	}

	const buybackInfo = await getBuybackInformation(currentVariantId);
	if (!buybackInfo) {
		log('No buyback information found for variant:', currentVariantId);
		// バリエーションにbuyback情報がない場合、UIを非表示にするか適切に処理
		return;
	}

	// トグルボタンのテキストを更新
	if (window.buybackToggle) {
		const plan = buybackInfo.plans[0];
		const maxPriceNum = plan.a_price;
		const maxPrice = maxPriceNum.toLocaleString();
		const maxPricePercentage = Math.round(plan.a_price_ratio * 100);
		
		window.buybackToggle.textContent = `最大 ${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? `${maxPricePercentage}%` : `￥${maxPrice}`} のバイバック保証`;
	}
	
	log('Buyback UI updated for variant:', currentVariantId, buybackInfo);
}

function setupVariantChangeObserver() {
	const variantInput = document.querySelector('quick-view-drawer details.menu-opening product-form form input[name="id"]');
	if (!variantInput) {
		log('Variant input not found for observer');
		return;
	}

	let lastVariantId = variantInput.value;
	log('Initial variant ID for observer:', lastVariantId);

	// メイン: input要素のchangeイベントを監視
	variantInput.addEventListener('change', function() {
		const currentVariantId = variantInput.value;
		if (currentVariantId !== lastVariantId) {
			log('Variant changed via change event:', lastVariantId, '->', currentVariantId);
			lastVariantId = currentVariantId;
			updateBuybackUIForVariant();
		}
	});

	log('Variant change observer setup complete (change event only)');
}

function getCurrentVariantId() {
	const variantInput = document.querySelector('quick-view-drawer details.menu-opening product-form form input[name="id"]');
	log('Current variant input:', variantInput);
	return variantInput ? parseInt(variantInput.value, 10) : null;
}

function getCurrentQuantity() {
	const quantityInput = document.querySelector('input[name="quantity"]');
	return quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
}

function setupBuybackUI(buybackInfo, originalButton) {
	const plan = buybackInfo.plans[0];
	const maxPriceNum = plan.a_price;
	const maxPrice = maxPriceNum.toLocaleString();
	const maxPricePercentage = Math.round(plan.a_price_ratio * 100);

	// powered by表記
	const poweredBy = document.createElement('a');
	poweredBy.style.cssText = `
		font-size: ${calcSize('0.8rem')};
		display: flex;
		gap: ${calcSize('0.2rem')};
		align-items: center;
		margin: ${calcSize('0.5rem')} 0;
		text-decoration: none;
	`;
	poweredBy.href = 'https://user.spixn.co.jp';
	poweredBy.target = '_blank';
	poweredBy.innerHTML = `<small style='font-size:${calcSize('0.7rem')};color:#888;'>
	${createSpixnMarkCircleSVG(USE_GREEN_MARK)}
	バイバック保証は <strong>spixn</strong> の提供するサービスです
	</small>`;

	// バイバック保証詳細リンクを作成
	const detailLink = document.createElement('a');
	detailLink.href = '#';
	detailLink.textContent = 'バイバック保証の詳細はこちら';
	detailLink.style.cssText = `
		font-size: ${calcSize('0.8rem')};
		font-weight: 600;
		color: ${SPIXN_GREEN3};
		text-decoration: none;
		display: block;
		margin: ${calcSize('0.5rem')} 0;
	`;
	detailLink.onclick = async (e) => {
		e.preventDefault();
		// ダイアログを開く時点で現在のバリエーションに基づいてbuyback情報を取得
		const currentVariantId = getCurrentVariantId();
		const currentBuybackInfo = await getBuybackInformation(currentVariantId);
		if (currentBuybackInfo) {
			showBuybackModal(currentBuybackInfo);
		} else {
			alert('選択された商品にはバイバック保証がありません');
		}
	};

	// トグルボタンを作成
	const toggleButton = document.createElement('button');
	toggleButton.type = 'button';
	toggleButton.textContent = `最大 ${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? `${maxPricePercentage}%` : `￥${maxPrice}`} のバイバック保証`;
	toggleButton.style.cssText = `
		padding: ${calcSize('0.5rem')} ${calcSize('1rem')};
		font-size: ${calcSize('0.9rem')};
		border: 1px solid ${SPIXN_GREEN};
		border-radius: 6px;
		cursor: pointer;
		background-color: white;
		color: ${BUYBACK_TOGGLE_BUTTON_INACTIVE_FONT_COLOR};
		margin: ${calcSize('0.5rem')} 0;
		display: block;
		width: 100%;
		font-family: ${BASE_FONT_FAMILY};
	`;
	
	toggleButton.onclick = () => {
		buybackToggleEnabled = !buybackToggleEnabled;
		updateToggleButtonState(toggleButton, buybackToggleEnabled);
		toggleAcceleratedCheckoutBlock(buybackToggleEnabled);
	};

	// Buy it now or Shop Pay button の下に説明を追加
	const descId = '__spixn_buy_it_now_notice__';
	const existingDescription = document.querySelector(`#${descId}`);
	if (existingDescription) {
		existingDescription.remove();
	}
	const payContainer = document.querySelector('.shopify-payment-button');
	if (payContainer) {
		const desc = document.createElement('div');
		desc.id = descId;
		desc.style.cssText = `
			font-size: ${calcSize('0.8rem')};
			color: ${SPIXN_BASE_COLOR};
			margin-top: ${calcSize('0.5rem')};
		`;
		desc.innerHTML = `バイバック保証をご利用の場合${originalButton.textContent}ボタンをお使いください。`;
		// payContainer.parentElement.nextElementSibling(payContainer, desc);
		payContainer.after(desc);
	}

	// マークを作成
	const mark = document.createElement('div');
	mark.innerHTML = createDashedCircleHTML();
	mark.style.cssText = `display: inline-block; margin-right: ${calcSize('0.5rem')};`;

    const chevron = document.createElement("div");
	chevron.style.cssText = `display: flex; align-items: center;color: ${SPIXN_GREEN3};`;
	chevron.innerHTML = createRightChevronSVG();

	// 詳細リンクとマークのコンテナ
	const linkContainer = document.createElement('div');
	linkContainer.style.cssText = `display: flex; align-items: center; margin: ${calcSize('0.5rem')} 0;`;
	linkContainer.appendChild(mark);
	linkContainer.appendChild(detailLink);
	linkContainer.appendChild(chevron);

	// 既存ボタンの前に挿入
	const buttonContainer = originalButton.parentElement;
	buttonContainer.insertBefore(poweredBy, originalButton);
	buttonContainer.insertBefore(linkContainer, originalButton);
	buttonContainer.insertBefore(toggleButton, originalButton);

	// グローバル参照用に保存
	window.buybackMark = mark;
	window.buybackToggle = toggleButton;
}

function updateToggleButtonState(toggleButton, enabled) {
	if (enabled) {
		toggleButton.style.background = SPIXN_BUTTON_ACTIVE_BACKGROUND;
		toggleButton.style.border = 'none';
		toggleButton.style.color = SPIXN_BUTTON_ACTIVE_COLOR;
		toggleButton.classList.add('spixn-selected');
	} else {
		toggleButton.style.background = SPIXN_BUTTON_INACTIVE_BACKGROUND;
		toggleButton.style.border = `1px solid ${SPIXN_GREEN}`;
		toggleButton.style.color = SPIXN_BUTTON_INACTIVE_COLOR;
		toggleButton.classList.remove('spixn-selected');
	}

	// マークも更新
	if (window.buybackMark) {
		window.buybackMark.innerHTML = enabled ? createCheckCircleHTML() : createDashedCircleHTML();
	}
}

function modifyOriginalButton(originalButton, buybackInfo) {
	// 元のクリックイベントを保存
	const originalOnClick = originalButton.onclick;
	const originalEventListeners = [];

	// 新しいクリックハンドラーを設定
	originalButton.onclick = null;
	
	// 新しいイベントリスナーを追加
	originalButton.addEventListener('click', function(e) {
		e.preventDefault();
		e.stopPropagation();

		if (buybackToggleEnabled) {
			// バイバック保証が有効な場合、両方をカートに追加
			addBothToCart(buybackInfo, originalButton);
		} else {
			// バイバック保証が無効な場合、プロンプトモーダルを表示
			showBuybackPromptModal(buybackInfo, originalButton);
		}
	});
}

// --- 既存の addSingleToCart を書き換え ---
function addSingleToCart(originalButton) {
  const currentVariantId = getCurrentVariantId();
  const currentQuantity = getCurrentQuantity();

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{ id: currentVariantId, quantity: currentQuantity }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  })
  .then(res => {
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  })
  .then(data => {
    if (CART_DISPLAY_MODE === 'drawer') {
      refreshSections(data.sections);
      const miniCart = document.querySelector('mini-cart');
      if (miniCart) {
        miniCart.open();
      }
    } else if (CART_DISPLAY_MODE === 'debug') {
      log('Debug mode: Cart add completed, staying on page');
    } else {
      // ページ遷移方式
      window.location.href = '/cart';
    }
  })
  .catch(err => {
    log("error in addSingleToCart:", err);
    alert('カート追加に失敗しました');
  });
}

// --- 既存の addBothToCart も同様に分岐 ---
async function addBothToCart(buybackInfo, originalButton) {
  const currentVariantId = getCurrentVariantId();
  const currentQuantity = getCurrentQuantity();
  
  // 現在のバリアントに対応するBuyback情報を取得
  const currentBuybackInfo = await getBuybackInformation(currentVariantId);
  if (!currentBuybackInfo) {
    alert('選択された商品にはバイバック保証がありません');
    return;
  }
  
  const buybackVariantId = currentBuybackInfo.buyback_variant_id;

  log('Adding both to cart:', {
    currentVariantId,
    buybackVariantId,
    currentQuantity,
    originalBuybackVariantId: buybackInfo.buyback_variant_id,
    updatedBuybackVariantId: buybackVariantId
  });

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [
        { id: currentVariantId, quantity: currentQuantity },
        { id: buybackVariantId, quantity: currentQuantity }
      ],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  })
  .then(res => {
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  })
  .then(data => {
    log('Cart add response:', data);
    if (CART_DISPLAY_MODE === 'drawer') {
      refreshSections(data.sections);
      const miniCart = document.querySelector('mini-cart');
      if (miniCart) {
        miniCart.open();
      }
    } else if (CART_DISPLAY_MODE === 'debug') {
      log('Debug mode: Cart add completed, staying on page');
    } else {
      window.location.href = '/cart';
    }
  })
  .catch(err => {
    log("error in addBothToCart:", err);
    alert('カート追加に失敗しました');
  });
}

function refreshSections(sections) {
	const parser = new DOMParser();
	Object.entries(sections).forEach(([sectionId, html]) => {
		const doc = parser.parseFromString(html, 'text/html');

		if (sectionId === 'cart-drawer') {
			const newDrawer = doc.querySelector('cart-drawer');
			const oldDrawer = document.querySelector('cart-drawer');
			if (newDrawer && oldDrawer && oldDrawer.parentNode) {
				oldDrawer.parentNode.replaceChild(newDrawer, oldDrawer);
			}
		}
		else if (sectionId === 'cart-icon-bubble') {
			const newBadge = doc.querySelector('[data-cart-count]');
			const oldBadge = document.querySelector('[data-cart-count]');
			if (newBadge && oldBadge) {
				oldBadge.textContent = newBadge.textContent;
			}
		}
	});
}

async function showBuybackPromptModal(buybackInfo, originalButton) {
	const plan = buybackInfo.plans[0];

	if (isModalVisible) return;
	isModalVisible = true;

	// 既存のSPIXNモーダルがあれば隠し場所に移動
	let existingModal = document.getElementById('spixn-buyback-modal');
	if (existingModal) {
		log('[MODAL-PROTECT] Moving existing SPIXN modal to hidden storage');
		// 隠し場所がなければ作成
		if (!document.getElementById('spixn-hidden-storage')) {
			const hiddenStorage = document.createElement('div');
			hiddenStorage.id = 'spixn-hidden-storage';
			hiddenStorage.style.display = 'none';
			document.body.appendChild(hiddenStorage);
		}
		// 既存要素を隠し場所に移動
		document.getElementById('spixn-hidden-storage').appendChild(existingModal);
		log('[MODAL-PROTECT] Existing modal moved to hidden storage');
	}

	// 【新アプローチ】SPIXNモーダルをShopifyモーダル内に配置して外部認識を回避
	log('[MODAL-PROTECT] Creating new SPIXN modal inside Shopify modal');
	
	// SPIXNモーダルをShopifyモーダル内に配置する
	const shopifyModalContent = document.querySelector('quick-view-drawer details[open] .quick-view__content');
	window.spixnModalContainer = shopifyModalContent || document.body;
	
	log('[MODAL-PROTECT] SPIXN modal will be placed inside:', window.spixnModalContainer.tagName);

	// ダイアログ内のpタグのmarginを0にするスタイルを追加
	addModalStyles();

	modal = document.createElement('div');
	modal.id = 'spixn-buyback-modal';
	Object.assign(modal.style, {
		position: 'fixed',
		top: '0',
		left: '0',
		width: '100vw',
		height: '100vh',
		backgroundColor: 'rgba(0,0,0,0.6)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: '10000',
		pointerEvents: 'auto', // SPIXNモーダルはクリック可能
	});

	const dialog = document.createElement('div');
	Object.assign(dialog.style, {
		backgroundColor: 'white',
		borderRadius: '12px',
		width: '90%',
		maxWidth: '520px',
		padding: `${calcSize('2rem')} ${calcSize('1.5rem')}`,
		fontSize: calcSize('0.95rem'),
		lineHeight: '1.6',
		position: 'relative',
		fontFamily: BASE_FONT_FAMILY,
	});

	const underlineStyle = `
		text-decoration: underline;
		text-decoration-color: #FFD1D1;
		text-decoration-thickness: 4px;
		text-decoration-skip-ink: none;
		text-underline-offset: ${calcSize('-0.05rem')};
	`;

	const feeLabel = buybackInfo.insurance_fee === 0 ? '無料' : 
		`手数料 ￥${buybackInfo.insurance_fee.toLocaleString()}`;


	dialog.innerHTML = `
		<div style="display: flex; justify-content: center; align-items: center; margin-bottom: ${calcSize('0.8rem')};margin-top: 10px;">
			<div id="spixn-buyback-prompt-title" style="display: flex; flex-direction:column; align-items: center; font-weight: bold; font-size: ${calcSize('1.0rem')};justify-content: center;">
				<div>
					この商品には
					<span style="color: #F3004D;">${feeLabel}</span>の
					バイバック保証がつけられます！利用しますか？
					</div>
			</div>
		</div>
		<ul style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin: ${calcSize('1rem')} auto; padding-inline-start: 0; font-weight: 600; font-size: ${calcSize("0.85rem")}">
			<li style="list-style: none;">
			任意で商品を<span style="${underlineStyle}">spixnにリセールできます。</span> <br />
			保証期間内${plan.insurance_period_days / 365}年であれば、<span style="${underlineStyle}">査定ランクに応じて買取を保証。</span>
			購入後のメールから<span style="${underlineStyle}">保証内容の確認や管理ができます。</span>
			</li>
		</ul>
		<div>
			<div style="margin-top: ${calcSize('1.5rem')}; font-size: ${calcSize('0.85rem')}; text-align: center;">
				<a id="spixn-show-buyback-modal-button" style="color: ${SPIXN_BASE_COLOR}; text-decoration: underline;cursor: pointer;">
					この商品のバイバック保証詳細を確認する
				</a>
			</div>
		</div>
		<div style="margin-top: ${calcSize('1.5rem')}; text-align: center;">
			<button id="spixn-buyback-modal-toggle" style="background: ${SPIXN_BUTTON_ACTIVE_BACKGROUND}; color: white; font-weight: bold; padding: ${calcSize('0.8rem')} ${calcSize('1rem')}; border-radius: 6px; border:none;font-size: ${calcSize('0.85rem')}; cursor: pointer; width: 100%;">
				最大￥${plan.a_price.toLocaleString()}のバイバック保証をつける
			</button>
		</div>
		<div style="margin-top: ${calcSize('1.5rem')}; text-align: center;">
			<button id="spixn-close-modal2" style="border:none; background:none; color:#222222; font-weight: bold; font-size: ${calcSize('0.9rem')}; cursor: pointer;">
				バイバック保証なしでカートへ
			</button>
		</div>
		<a style="margin-top: ${calcSize('1rem')}; text-align: center; font-size: ${calcSize('0.7rem')}; color: #888;display:flex;justify-content:center;align-items:center;gap:${calcSize('0.5rem')};text-decoration: none;"
		   href="https://user.spixn.co.jp"
		   target="_blank"
		>
			<small style='font-size:${calcSize('0.7rem')};color:#888;'>
				${createSpixnMarkCircleSVG(USE_GREEN_MARK)}
				バイバック保証は <strong>spixn</strong> の提供するサービスです
			</small>
		</a>
		<button id="spixn-close-modal" style="position: absolute; top: ${calcSize('1rem')}; right: ${calcSize('1rem')}; background: none; border: none; font-size: ${calcSize('1.5rem')}; cursor: pointer;">×</button>
	`;

	// 背景クリックでモーダルを閉じる処理（通常のモーダル動作）
	modal.addEventListener('click', (e) => {
		if (e.target === modal) {
			// 背景クリックでモーダルを閉じる
			const closeEvent = { preventDefault: () => {} };
			closeModal(closeEvent);
		}
	});

	modal.appendChild(dialog);
	// SPIXNモーダルをShopifyモーダル内に配置（外部認識を回避）
	window.spixnModalContainer.appendChild(modal);
	log('[MODAL-PROTECT] SPIXN modal placed inside Shopify modal');

	const closeModal = e => {
		log('[MODAL-PROTECT] closeModal called - using display:none instead of remove');
		e.preventDefault();
		// modal.remove() の代わりに非表示にする
		modal.style.display = 'none';
		isModalVisible = false;
		log('[MODAL-PROTECT] SPIXN modal hidden (not removed)');
	};

	const showBuybackModalButton = document.getElementById('spixn-show-buyback-modal-button');
	showBuybackModalButton.addEventListener('click', async e => {
		e.preventDefault();
		closeModal(e);
		setTimeout(async () => {
			// ダイアログを開く時点で現在のバリエーションに基づいてbuyback情報を取得
			const currentVariantId = getCurrentVariantId();
			const currentBuybackInfo = await getBuybackInformation(currentVariantId);
			if (currentBuybackInfo) {
				showBuybackModal(currentBuybackInfo);
			} else {
				alert('選択された商品にはバイバック保証がありません');
			}
		}, 100);
	});

	document.getElementById('spixn-close-modal')?.addEventListener('click', closeModal);
	
	document.getElementById('spixn-close-modal2')?.addEventListener('click', e => {
		closeModal(e);
		setTimeout(() => {
			addSingleToCart(originalButton);
		}, 100);
	});

	const modalToggle = document.getElementById('spixn-buyback-modal-toggle');
	modalToggle.addEventListener('click', e => {
		// トグルを有効にして保証付きでカートに追加
		buybackToggleEnabled = true;
		updateToggleButtonState(window.buybackToggle, true);
		closeModal(e);
		setTimeout(() => {
			addBothToCart(buybackInfo, originalButton);
		}, 100);
	});
}

async function showBuybackModal(buybackInfo) {
	if (isModalVisible) return;
	isModalVisible = true;

	// 既存のSPIXNモーダルがあれば隠し場所に移動
	let existingModal = document.getElementById('spixn-buyback-modal');
	if (existingModal) {
		log('[MODAL-PROTECT] showBuybackModal - Moving existing SPIXN modal to hidden storage');
		// 隠し場所がなければ作成
		if (!document.getElementById('spixn-hidden-storage')) {
			const hiddenStorage = document.createElement('div');
			hiddenStorage.id = 'spixn-hidden-storage';
			hiddenStorage.style.display = 'none';
			document.body.appendChild(hiddenStorage);
		}
		// 既存要素を隠し場所に移動
		document.getElementById('spixn-hidden-storage').appendChild(existingModal);
		log('[MODAL-PROTECT] showBuybackModal - Existing modal moved to hidden storage');
	}

	// 【新アプローチ】SPIXNモーダルをShopifyモーダル内に配置して外部認識を回避
	log('[MODAL-PROTECT] showBuybackModal - Creating new SPIXN modal inside Shopify modal');
	
	// SPIXNモーダルをShopifyモーダル内に配置する
	const shopifyModalContent = document.querySelector('quick-view-drawer details[open] .quick-view__content');
	log('[MODAL-PROTECT] shopifyModalContent:', shopifyModalContent);
	window.spixnModalContainer = shopifyModalContent || document.body;
	
	log('[MODAL-PROTECT] showBuybackModal - SPIXN modal will be placed inside:', window.spixnModalContainer.tagName);

	// ダイアログ内のpタグのmarginを0にするスタイルを追加
	addModalStyles();

	const plan = buybackInfo.plans[0];
	const selected = buybackToggleEnabled;

	const modal = document.createElement('div');
	modal.id = 'spixn-buyback-modal';
	Object.assign(modal.style, {
		position: 'fixed',
		top: '0',
		left: '0',
		width: '100vw',
		height: '100vh',
		backgroundColor: 'rgba(0,0,0,0.6)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: '10000',
	});

	const dialog = document.createElement('div');
	Object.assign(dialog.style, {
      backgroundColor: 'white',
      borderRadius: '12px',
      width: '520px;',
      maxWidth: '520px',
      padding: '2rem 1.5rem',
      fontSize: '0.95rem',
      lineHeight: '1.6',
      position: 'relative',
      transformOrigin: "center center",
      transition: "transform 0.2s ease-out",
	});

	const baseWidth = 520; // 基準となる幅
	const baseHeight = 720; // 基準となる高さ
	function adjustScale() {
		const w = window.innerWidth;
		const h = window.innerHeight;
		// 幅と高さの縮小率を計算
		const scaleW = w < baseWidth ? (w / baseWidth) : 1;
		const scaleH = h < baseHeight ? (h / baseHeight) : 1;
		// 小さい方の縮小率を適用
		const scale = Math.min(scaleW, scaleH);
		dialog.style.transform = `scale(${scale})`;
	}
    adjustScale();

    window.addEventListener('resize', adjustScale);
    window.addEventListener('load', adjustScale);

	const blockStyle = `
		border: 1px solid #e0d7fa;
		border-radius: 12px;
        padding: 1rem;
        margin: 1rem 0;
		background-color: #f9f7fe;
		color: ${SPIXN_BASE_COLOR};
	`;

	const priceRangeTitle = `
		<div style="display: flex; flex-direction: column; justify-content: end; align-items: end; margin-bottom: ${calcSize('0.8rem')}; font-size: ${calcSize('0.7rem')};font-weight: bold;">
			<span style="color: ${SPIXN_BASE_COLOR};">紫色: バイバック保証額</span>
			<span style="color: #A3A3A3;">グレー: 2次流通品の主要取引価格帯（spixn調査）</span>
		</div>
	`;

	const maxPriceNum = plan.a_price;
	const maxPrice = maxPriceNum.toLocaleString();
	const insuranceFee = buybackInfo.insurance_fee.toLocaleString();
	const maxPricePercentage = Math.round(plan.a_price_ratio * 100);

	const buttonLabel = selected
		? 'バイバック保証をはずす'
		: `最大${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? '' : '￥'}${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? `${maxPricePercentage}%` : maxPrice} のバイバック保証をつける`;

	dialog.innerHTML = `
		<div style="display: flex; justify-content: space-between; align-items: baseline; margin-bottom: ${calcSize('0.8rem')};">
			<div id="spixn-buyback-title" style="white-space: nowrap; display: flex; align-items: center; gap: ${calcSize('0.5rem')}; font-weight: normal; font-size: ${calcSize('0.85rem')};">
				バイバック保証 ${selected ? '設定中' : '未選択'}
			</div>
			<div style="display: flex; justify-content: space-between; gap: 10px; align-items: baseline; font-size: ${calcSize('0.9rem')}; color: #666;">
				<p id="spixn-buyback-period" style="border-radius: 20px; padding: 0 ${calcSize('0.5rem')};margin:0;">
					保証期間 <span style="font-size:${calcSize('1.5rem')}">${plan.insurance_period_days / 365}</span>年間
				</p>
				<button id="spixn-close-modal" style="background: none; border: none; font-size: ${calcSize('1.5rem')}; cursor: pointer; padding: 0;">×</button>
			</div>
		</div>
		<div style="display: flex; align-items: baseline;color: ${SPIXN_BASE_COLOR};font-weight: 700;justify-content:center;margin-bottom: 20px;flex-wrap: wrap;">
			<span style="font-size: ${calcSize('1.2rem')}; color: #F3004D;">手数料</span>
			<span style="font-size: ${calcSize('1.0rem')};">&nbsp;</span>
			<span style="color: #F3004D; font-size: ${calcSize('1.1rem')};">￥</span>
			<span style="font-size: ${calcSize('1.4rem')}; color: #F3004D;">${insuranceFee}</span>
			<span style="font-size: ${calcSize('0.5rem')};">&nbsp;</span>
			<span style="font-size: ${calcSize('1.2rem')};">で最大</span>
			<span style="font-size: ${calcSize('0.5rem')};">&nbsp;</span>
			<span style="font-size: ${calcSize('1.1rem')}";>${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? '' : '￥'}</span>
			<span style="font-size: ${calcSize('1.4rem')};">${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? maxPricePercentage : maxPrice}</span>
			<span style="font-size: ${calcSize('1.1rem')}";>${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? '%' : ''}</span>
			<span style="font-size: ${calcSize('1.2rem')};">のバイバック保証適用</span>
		</div>

		<div id="spixn-buyback-modal-sub-message" style="
			margin-bottom: 30px;
			text-align: center;
			color: #F3004D;
			font-weight: 500;
		">
			${createSpixnMarkCircleSVG(USE_GREEN_MARK)}
			この保証は外部サービス「<a style="color: inherit;" target="_blank" href="https://user.spixn.co.jp">spixn</a>」によって提供されています。 <br />
			保証を有効にするには、購入後に注文時と同じメールアドレスでspixnに会員登録してください。
			<div style="margin-top: ${calcSize('0.5rem')};margin-bottom: ${calcSize('0.8rem')}; font-size: ${calcSize('0.7rem')}; text-align: center;">
				<a href="/pages/spixn" target="_blank" style="color: ${SPIXN_BASE_COLOR}; text-decoration: underline;">バイバック保証について更に詳しくみる</a>
			</div>
		</div>		
		
		
		<div id="spixn-buyback-modal-core" style="${blockStyle}">
		    <div id="spixn-buyback-modal-core-content">
				<div id="spixn-buyback-modal-core-title" style="background-color: #f1eaff; color: ${SPIXN_BASE_COLOR}; padding: ${calcSize('0.3rem')}; border-radius: 20px; font-size: ${calcSize('0.85rem')}; margin: -26px auto ${calcSize('1rem')}; text-align: center; width: ${calcSize('16rem', ' + 25px')};">
					保証期間内であればいつでも利用可能
				</div>
				<p style="font-size: ${calcSize('0.75rem')}; margin-bottom: ${calcSize('1.2rem')}; text-align: left;">
					受取時の状態（A・B・C）を評価し、該当する保証金額をお支払い。
					Cに至らない品質の場合は再評価し、適正額をお支払いします。
				</p>
				${BUYBACK_MODAL_SHOW_PRICE_RANGE ? priceRangeTitle : ''}
				<ul style="list-style: none; padding: 0; margin: 0;">
					${['A', 'B', 'C']
						.map((grade, idx) => {
							const labels = [
								'未使用に近い',
								'ほとんどキズがない',
								'ややキズや汚れがある',
							];
							const descriptions = [
								'数回しか使用しておらず、傷や汚れがない',
								'よく見ないとわからない程度の傷や汚れがある',
								'目立たない傷や汚れがある',
							];
							const prices = [plan.a_price, plan.b_price, plan.c_price];
							const percentages = [
								plan.a_price_ratio,
								plan.b_price_ratio,
								plan.c_price_ratio,
							].map(p => Math.round(p * 100));
							const ranges = [
								`￥${plan.a_min_price.toLocaleString()} 〜 ￥${plan.a_max_price.toLocaleString()}`,
								`￥${plan.b_min_price.toLocaleString()} 〜 ￥${plan.b_max_price.toLocaleString()}`,
								`￥${plan.c_min_price.toLocaleString()} 〜 ￥${plan.c_max_price.toLocaleString()}`,
							].map(
								r => `<span style="font-size: ${calcSize('0.8rem')};color:#A3A3A3">${r}</span>`,
							);

							return `
							<li style="display: flex; justify-content: space-between; align-items: center; margin-bottom: ${calcSize('1rem')};">
								<div style="display: flex; align-items: center;">
									<div style="background: ${SPIXN_BASE_COLOR}; color: white; font-weight: bold; border-radius: 50%;width: ${calcSize('2rem')}; height: ${calcSize('2rem')}; min-width: ${calcSize('2rem')}; min-height: ${calcSize('2rem')}; text-align: center; line-height: ${calcSize('2rem')}; margin-right: ${calcSize('0.8rem')};font-size: ${calcSize('0.8rem')};">${grade}</div>
									<div>
										<div style="font-size: ${calcSize('0.75rem')}; font-weight: bold; text-align: left;">${labels[idx]}</div>
										<div style="text-align: left;">${descriptions[idx]}</div>
									</div>
								</div>
								<div style="color: ${SPIXN_BASE_COLOR}; font-size: ${calcSize('1.5rem')}; white-space: nowrap;font-weight: 500;display:flex; flex-direction:column;align-items:end;">
									<p style="display:flex; align-items: baseline;">
										<span style="font-size: ${calcSize('0.8rem')};">${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? '' : '￥'}</span>
										${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? percentages[idx] : prices[idx].toLocaleString()}
										<span style="font-size: ${calcSize('0.8rem')};">${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? '%' : ''}</span>
									</p>
									${BUYBACK_MODAL_SHOW_PRICE_RANGE ? ranges[idx] : ''}
								</div>
							</li>
						`;
						})
						.join('')}
				</ul>
			</div>
		</div>
		<div style="margin-top: ${calcSize('1.5rem')}; text-align: center;">
			<button id="spixn-buyback-modal-toggle" style="background: ${selected ? SPIXN_BASE_COLOR : 'white'}; color: ${selected ? 'white' : SPIXN_BASE_COLOR}; font-weight: bold; padding: ${calcSize('0.8rem')} ${calcSize('1rem')}; border-radius: 6px; border:none;font-size: ${calcSize('0.9rem')}; cursor: pointer; width: 100%;">
				${buttonLabel}
			</button>
		</div>
		<div style="margin-top: ${calcSize('1.5rem')}; text-align: center;">
			<button id="spixn-close-modal2" style="border:none; background:none; color:${SPIXN_BASE_COLOR}; font-weight: bold; font-size: ${calcSize('0.9rem')}; cursor: pointer;">
				閉じる
			</button>
		</div>
		<a href="mailto:contact@liberont.com" target="_blank" style="margin-top: ${calcSize('2rem')}; text-align: center; font-size: ${calcSize('0.7rem')}; color: #26202C;display:block;text-decoration: none;">
			バイバック保証サービスの運営窓口にお問い合わせはこちら
			<span style="border: 1px solid #A3A3A3; border-radius: 50%; background-color:#A3A3A3; color: #FFFFFF;padding: 0 ${calcSize('0.4rem')}; font-size: ${calcSize('0.75rem')}; margin-left: ${calcSize('0.3rem')};">i</span>
		</a>
	`;

	modal.appendChild(dialog);
	// SPIXNモーダルをShopifyモーダル内に配置（外部認識を回避）
	window.spixnModalContainer.appendChild(modal);
	log('[MODAL-PROTECT] showBuybackModal - SPIXN modal placed inside Shopify modal');

	// 背景クリックでモーダルを閉じる処理（通常のモーダル動作）
	modal.addEventListener('click', (e) => {
		if (e.target === modal) {
			// 背景クリックでモーダルを閉じる
			const closeEvent = { preventDefault: () => {} };
			closeModal(closeEvent);
		}
	});

	const closeModal = e => {
		log('[MODAL-PROTECT] showBuybackModal - closeModal called - using display:none');
		e.preventDefault();
		// modal.remove() の代わりに非表示にする
		modal.style.display = 'none';
		isModalVisible = false;
		log('[MODAL-PROTECT] showBuybackModal - SPIXN modal hidden (not removed)');
	};

	document.getElementById('spixn-close-modal')?.addEventListener('click', closeModal);
	document.getElementById('spixn-close-modal2')?.addEventListener('click', closeModal);

	const modalToggle = document.getElementById('spixn-buyback-modal-toggle');
	modalToggle.addEventListener('click', () => {
		buybackToggleEnabled = !buybackToggleEnabled;
		updateToggleButtonState(window.buybackToggle, buybackToggleEnabled);
		syncModalState(buybackInfo);
	});

	syncModalState(buybackInfo);
}

function syncModalState(buybackInfo) {
	const plan = buybackInfo.plans[0];
	const modalToggle = document.getElementById('spixn-buyback-modal-toggle');
	const title = document.getElementById('spixn-buyback-title');
	const period = document.getElementById('spixn-buyback-period');
	const core = document.getElementById('spixn-buyback-modal-core');
    const coreContent = document.getElementById('spixn-buyback-modal-core-content');
	const coreTitle = document.getElementById('spixn-buyback-modal-core-title');

	const isSelected = buybackToggleEnabled;

	if (modalToggle) {
		modalToggle.style.background = isSelected ? SPIXN_BUTTON_INACTIVE_BACKGROUND : SPIXN_BUTTON_ACTIVE_BACKGROUND;
		modalToggle.style.color = isSelected ? SPIXN_BUTTON_INACTIVE_COLOR : SPIXN_BUTTON_ACTIVE_COLOR;
		modalToggle.style.border = isSelected ? `1px solid ${SPIXN_GREEN}` : 'none';
		
		const maxPriceNum = plan.a_price;
		const maxPrice = maxPriceNum.toLocaleString();
		const maxPricePercentage = Math.round(plan.a_price_ratio * 100);

		const buttonLabel = isSelected
			? 'バイバック保証をはずす'
			: `最大${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? '' : '￥'}${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? `${maxPricePercentage}%` : maxPrice} のバイバック保証をつける`;

		modalToggle.textContent = buttonLabel;
	}

	if (core) {
		core.style.border = 'none';
		core.style.background = isSelected ? `${SPIXN_BUTTON_ACTIVE_BACKGROUND}` : '#F5F4EE';
		core.style.padding = '4px';
	}
	if (coreContent) {
		coreContent.style.backgroundColor = isSelected ? SPIXN_LIGHT_GREEN : 'white';
		coreContent.style.borderRadius = '9px';
		coreContent.style.padding = '1rem';
	}

	if (coreTitle) {
		coreTitle.style.background = isSelected ? SPIXN_BUTTON_ACTIVE_BACKGROUND : '#F5F4EE';
		coreTitle.style.color = isSelected ? 'white' : '#4A2D57';
	}

	if (title) {
		title.style.color = isSelected ? '#222222' : '#A3A3A3';
		title.innerHTML = `${isSelected ? createCheckCircleHTML() : createDashedCircleHTML()}バイバック保証 ${isSelected ? '設定中' : '未選択'}`;
	}
	
	if (period) {
		period.style.backgroundColor = isSelected ? '#222222' : 'transparent';
		period.style.color = isSelected ? 'white' : '#A3A3A3';
	}
	toggleAcceleratedCheckoutBlock(isSelected);
}

function createDashedCircleHTML() {
	return `<div style="display: flex;align-items:center; width: 14px;height:14px;text-align: center;line-height: ${calcSize('1.5rem')};border-radius: 50%;border: dashed 1px ${SPIXN_BASE_COLOR};"></div>`;
}

function createCheckCircleHTML(fgColor = 'white', bgColor = SPIXN_GREEN_FOR_CHECK) {
	return `
		<div style="display: flex; align-items: center">
			<svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="10" cy="10" r="10" fill="${bgColor}"/>
			<g clip-path="url(#clip0_1_8223)">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M15.6818 5.89941C15.8492 6.06684 15.9432 6.29391 15.9432 6.53066C15.9432 6.76741 15.8492 6.99447 15.6818 7.16191L8.98952 13.8542C8.90108 13.9426 8.79609 14.0128 8.68052 14.0607C8.56496 14.1086 8.4411 14.1332 8.31601 14.1332C8.19093 14.1332 8.06706 14.1086 7.9515 14.0607C7.83594 14.0128 7.73094 13.9426 7.6425 13.8542L4.3175 10.5298C4.23222 10.4474 4.1642 10.3489 4.11741 10.2399C4.07062 10.131 4.04599 10.0139 4.04496 9.8953C4.04393 9.77675 4.06652 9.65918 4.11141 9.54945C4.1563 9.43972 4.2226 9.34003 4.30643 9.2562C4.39027 9.17237 4.48996 9.10607 4.59968 9.06118C4.70941 9.01628 4.82698 8.99369 4.94554 8.99472C5.06409 8.99575 5.18125 9.02038 5.29018 9.06718C5.39912 9.11397 5.49764 9.18199 5.58 9.26727L8.31571 12.003L14.4187 5.89941C14.5016 5.81644 14.6001 5.75062 14.7084 5.70571C14.8168 5.66081 14.9329 5.6377 15.0502 5.6377C15.1675 5.6377 15.2837 5.66081 15.3921 5.70571C15.5004 5.75062 15.5989 5.81644 15.6818 5.89941Z" fill="${fgColor}" stroke="${fgColor}" stroke-width="0.6"/>
			</g>
			<defs>
			<clipPath id="clip0_1_8223">
			<rect width="14.2857" height="14.2857" fill="${fgColor}" transform="translate(2.85693 2.85742)"/>
			</clipPath>
			</defs>
			</svg>
		</div>
	`;
}

function createPoweredBySpixnSVG() {
	return `
<svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.6001 14.347C2.69467 14.7065 2.98826 14.9085 3.45471 14.9085C3.91633 14.9085 4.08436 14.743 4.08436 14.4694C4.08436 14.1795 3.89039 14.0658 3.24375 13.9072C1.7728 13.5445 1.53201 13.0891 1.53201 12.4521C1.53201 11.7887 2.00097 11.0845 3.36312 11.0845C4.7326 11.0845 5.19606 11.8323 5.23508 12.4441H4.04648C4.00631 12.2772 3.89498 11.962 3.30711 11.962C2.89392 11.962 2.76032 12.1457 2.76032 12.3481C2.76032 12.5726 2.90058 12.6812 3.63261 12.8531C5.1389 13.2034 5.35215 13.7199 5.35215 14.3817C5.35215 15.1293 4.78333 15.81 3.40673 15.81C2.0361 15.81 1.47003 15.1484 1.37109 14.348L2.6001 14.347Z" fill="#231815"/>
<path d="M7.28327 15.3045V17.4335H6.04095V12.2769C6.04095 11.9117 6.04095 11.5509 6.03223 11.1887H7.24287C7.26667 11.3752 7.28016 11.563 7.28327 11.7511C7.47701 11.4198 7.88009 11.084 8.59583 11.084C9.60974 11.084 10.3941 11.9333 10.3941 13.3336C10.3941 14.9269 9.51838 15.8092 8.42458 15.8092C7.78735 15.809 7.4552 15.5687 7.28327 15.3045ZM9.12562 13.3815C9.12562 12.554 8.79071 12.0869 8.19595 12.0869C7.48596 12.0869 7.23414 12.5425 7.23414 13.4522C7.23414 14.314 7.46691 14.8153 8.14247 14.8153C8.80403 14.8153 9.12562 14.3011 9.12562 13.3815Z" fill="#231815"/>
<path d="M11.1268 11.1891H12.377V15.7043H11.1268V11.1891ZM12.4979 9.8017C12.4979 9.94925 12.4542 10.0935 12.3722 10.2162C12.2902 10.3389 12.1737 10.4345 12.0374 10.4909C11.9011 10.5474 11.7511 10.5622 11.6063 10.5334C11.4616 10.5046 11.3287 10.4336 11.2244 10.3292C11.12 10.2249 11.049 10.092 11.0202 9.94724C10.9914 9.80252 11.0062 9.65252 11.0626 9.5162C11.1191 9.37988 11.2147 9.26337 11.3374 9.18139C11.4601 9.09942 11.6043 9.05566 11.7519 9.05566C11.8499 9.05566 11.9469 9.07496 12.0374 9.11245C12.1279 9.14994 12.2101 9.2049 12.2794 9.27417C12.3487 9.34345 12.4036 9.42569 12.4411 9.5162C12.4786 9.60672 12.4979 9.70373 12.4979 9.8017Z" fill="#231815"/>
<path d="M14.4004 11.189C14.8709 12.0383 15.0622 12.3732 15.1983 12.6041H15.207C15.3626 12.3305 15.6374 11.8331 16.0045 11.189H17.3923L15.9282 13.3385L17.3879 15.7042H15.9737C15.5683 14.9398 15.3144 14.4458 15.1818 14.1864H15.173C15.0534 14.424 14.7454 15.0096 14.3756 15.7042H13.0098L14.4077 13.504L13.018 11.189H14.4004Z" fill="#231815"/>
<path d="M17.9296 12.3268C17.9296 11.943 17.9296 11.5234 17.9209 11.1891H19.1315C19.1568 11.3058 19.1731 11.6193 19.1797 11.7646C19.3333 11.4809 19.6985 11.0845 20.4895 11.0845C21.3965 11.0845 21.9857 11.6974 21.9857 12.832V15.7044H20.7356V12.9709C20.7356 12.4634 20.5664 12.0956 20.0148 12.0956C19.4837 12.0956 19.1797 12.3908 19.1797 13.1881V15.7044H17.9296V12.3268Z" fill="#231815"/>
<path d="M0.617323 6.04785V3.13876H1.70823C1.93172 3.13876 2.11922 3.18043 2.27073 3.26376C2.42319 3.34709 2.53825 3.46168 2.6159 3.60751C2.6945 3.7524 2.7338 3.91717 2.7338 4.10183C2.7338 4.28838 2.6945 4.4541 2.6159 4.59899C2.5373 4.74387 2.4213 4.85798 2.26789 4.94132C2.11448 5.0237 1.92556 5.0649 1.70113 5.0649H0.978118V4.63166H1.63011C1.76079 4.63166 1.8678 4.60893 1.95113 4.56348C2.03446 4.51802 2.09602 4.45552 2.13579 4.37598C2.17651 4.29643 2.19687 4.20505 2.19687 4.10183C2.19687 3.99861 2.17651 3.9077 2.13579 3.8291C2.09602 3.7505 2.03399 3.68942 1.94971 3.64586C1.86638 3.60136 1.75889 3.5791 1.62727 3.5791H1.14431V6.04785H0.617323ZM4.04927 6.09047C3.8362 6.09047 3.65154 6.04359 3.49529 5.94984C3.33904 5.85609 3.21783 5.72493 3.13166 5.55637C3.04643 5.38781 3.00381 5.19084 3.00381 4.96547C3.00381 4.74009 3.04643 4.54264 3.13166 4.37314C3.21783 4.20363 3.33904 4.072 3.49529 3.97825C3.65154 3.8845 3.8362 3.83762 4.04927 3.83762C4.26234 3.83762 4.447 3.8845 4.60325 3.97825C4.7595 4.072 4.88023 4.20363 4.96546 4.37314C5.05164 4.54264 5.09472 4.74009 5.09472 4.96547C5.09472 5.19084 5.05164 5.38781 4.96546 5.55637C4.88023 5.72493 4.7595 5.85609 4.60325 5.94984C4.447 6.04359 4.26234 6.09047 4.04927 6.09047ZM4.05211 5.67853C4.16764 5.67853 4.26423 5.64681 4.34188 5.58336C4.41953 5.51897 4.4773 5.43279 4.51518 5.32484C4.554 5.21689 4.57342 5.09662 4.57342 4.96404C4.57342 4.83052 4.554 4.70978 4.51518 4.60183C4.4773 4.49293 4.41953 4.40628 4.34188 4.34189C4.26423 4.27749 4.16764 4.24529 4.05211 4.24529C3.93374 4.24529 3.83525 4.27749 3.75666 4.34189C3.679 4.40628 3.62077 4.49293 3.58194 4.60183C3.54406 4.70978 3.52512 4.83052 3.52512 4.96404C3.52512 5.09662 3.54406 5.21689 3.58194 5.32484C3.62077 5.43279 3.679 5.51897 3.75666 5.58336C3.83525 5.64681 3.93374 5.67853 4.05211 5.67853Z" fill="#26202C"/>
</svg>
	`;
}

/**
 * SPIXN API機能の初期化
 * @param {string} shopId - Shop ID
 */
async function initializeSpixnAPI(shopId) {
	try {
		log('[SPIXN Modal] Initializing SPIXN API...');
		
		// Shop IDを設定
		if (shopId && validateShopId(shopId)) {
			setShopId(shopId);
			log('[SPIXN Modal] Shop ID set:', shopId);
			log('[SPIXN Modal] SPIXN API initialization completed');
			return true;
		} else {
			console.warn('[SPIXN Modal] Shop ID not available or invalid:', shopId);
			return false;
		}
	} catch (error) {
		console.error('[SPIXN Modal] SPIXN API initialization failed:', error);
		return false;
	}
}

/**
 * 初期化処理（外部から呼び出し用）
 * @param {string} shopId - Shop ID
 * @param {string} [apiBaseUrl] - API Base URL（オプション）
 * @param {Object} [options] - 初期化オプション
 * @param {boolean} [options.debugMode] - デバッグモード
 */
async function initialize(shopId, apiBaseUrl, options = {}) {
	log('🚀 [SPIXN Modal] Initializing Shopify Modal Buyback Display');
	log('🔍 [SPIXN Modal] Parameters:', { shopId, apiBaseUrl, options });
	
	// オプションの設定
	if (options.debugMode !== undefined) {
		DEBUG_MODE = options.debugMode;
		log = DEBUG_MODE ? console.log : () => {};
	}
	
	log('⚙️ [SPIXN Modal] Configuration:', { debugMode: DEBUG_MODE });
	
	// API Base URLが指定されている場合は設定
	if (apiBaseUrl) {
		setApiBaseUrl(apiBaseUrl);
		log('🌐 [SPIXN Modal] API Base URL set:', apiBaseUrl);
	}
	
	// Shop IDの詳細チェック
	log('🏪 [SPIXN Modal] Shop ID validation:', {
		provided: shopId,
		type: typeof shopId,
		valid: validateShopId(shopId),
		windowShopify: window.Shopify?.shop
	});
	
	// API初期化を先に実行
	log('🔧 [SPIXN Modal] Starting API initialization...');
	const apiInitialized = await initializeSpixnAPI(shopId);
	
	if (!apiInitialized) {
		console.warn('❌ [SPIXN Modal] API initialization failed, skipping setup');
		return;
	}
	
	log('✅ [SPIXN Modal] API initialization successful, proceeding with setup');
	
	// モーダル監視の初期化
	log('👀 [SPIXN Modal] Setting up modal observer...');
	initializeModalObserver();
	
	log('🎉 [SPIXN Modal] Initialization complete!');
}

function createSpixnMarkCircleSVG(useGreenMark=true) {
	const color = useGreenMark ? SPIXN_GREEN_FOR_MARK : SPIXN_BASE_COLOR;
	return `
		<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: sub;">
		<g clip-path="url(#clip0_1427_3087)">
		<path d="M7.00123 13.0025C10.5918 13.0025 13.5025 10.0918 13.5025 6.50123C13.5025 2.9107 10.5918 0 7.00123 0C3.4107 0 0.5 2.9107 0.5 6.50123C0.5 10.0918 3.4107 13.0025 7.00123 13.0025Z" fill="${color}"/>
		<path d="M3.96566 9.09757C4.42183 9.55602 5.04143 9.81448 5.68816 9.8161H5.71277C6.06158 9.80932 6.40539 9.73191 6.72344 9.58853C7.04149 9.44516 7.32717 9.2388 7.56323 8.98192L7.60753 8.9327L7.87575 8.63496L9.59825 9.83579H11.3774L9.04951 8.21171L5.78905 5.92816L5.01146 5.3868C4.9124 5.31079 4.83161 5.21357 4.77501 5.10227C4.71841 4.99097 4.68744 4.86841 4.68437 4.74359C4.6813 4.61876 4.70622 4.49483 4.75728 4.38088C4.80834 4.26694 4.88426 4.16587 4.97947 4.08508C5.19671 3.89346 5.47725 3.78914 5.76691 3.79226C6.36486 3.79226 6.85209 4.20812 6.85455 4.71995C6.85491 4.77537 6.84913 4.83067 6.83732 4.88482L6.81763 4.9611C6.79964 5.01287 6.77742 5.06307 6.7512 5.1112C6.71941 5.16848 6.68146 5.22212 6.638 5.27114L6.48298 5.45324L7.32209 6.0389L7.41067 5.93801C7.49933 5.83491 7.57687 5.72273 7.64198 5.60334C7.70324 5.4932 7.75273 5.3769 7.78962 5.25638L7.82161 5.14565V5.11858C7.85105 4.98608 7.8659 4.85076 7.8659 4.71503C7.8659 3.64215 6.91606 2.77351 5.75952 2.77351C5.21493 2.76899 4.68831 2.96823 4.28309 3.3321C4.08469 3.50684 3.92586 3.7219 3.81722 3.96293C3.70859 4.20396 3.65265 4.46541 3.65315 4.72979C3.65661 5.01058 3.7227 5.28706 3.84658 5.53908C3.97046 5.79109 4.14901 6.01228 4.36922 6.18653L4.38398 6.19884L7.01941 8.037L6.8324 8.24617C6.68824 8.41205 6.51126 8.54624 6.31262 8.64027C6.11398 8.73429 5.898 8.78611 5.67832 8.79245C5.30467 8.79231 4.94597 8.64565 4.67926 8.38397C4.48976 8.18669 4.38319 7.92421 4.38152 7.65067V7.11177H3.36524V7.64082C3.36468 7.91118 3.41743 8.179 3.52045 8.42896C3.62348 8.67892 3.77476 8.90612 3.96566 9.09757Z" fill="white"/>
		<path d="M9.25796 5.54199L8.24414 6.68131L9.08325 7.26942L10.6212 5.54199H9.25796Z" fill="white"/>
		<path d="M10.5423 4.91367C10.9065 4.91367 11.2018 4.61842 11.2018 4.2542C11.2018 3.88998 10.9065 3.59473 10.5423 3.59473C10.1781 3.59473 9.88281 3.88998 9.88281 4.2542C9.88281 4.61842 10.1781 4.91367 10.5423 4.91367Z" fill="white"/>
		</g>
		<defs>
		<clipPath id="clip0_1427_3087">
		<rect width="13" height="13" fill="white" transform="translate(0.5)"/>
		</clipPath>
		</defs>
		</svg>
	`;
}

function createRightChevronSVG(){
	return `
		<svg width=20 height=20 viewBox="0 0 24 24" focusable="false">
		<path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
		</svg>	
	`;
}

/**
 * 自動初期化処理（従来の互換性のため）
 */
async function autoInitialize() {
	// Shop IDを自動取得
	const shopId = window.Shopify?.shop;
	if (shopId && validateShopId(shopId)) {
		await initialize(shopId);
	} else {
		console.warn('[SPIXN Modal] Shop ID not available for auto-initialization');
	}
}

document.addEventListener('DOMContentLoaded', function() {
	autoInitialize();
});

// グローバルに公開（外部から呼び出し用）
window.ShopifyBuybackModal = {
	initialize,                    // メイン実行関数（shopId, apiBaseUrlを引数で受け取る）
	getBuybackInformation,        // バイバック情報取得
	getShopId,                    // Shop ID取得
	setShopId,                    // Shop ID設定
	getApiBaseUrl,                // API Base URL取得
	setApiBaseUrl                 // API Base URL設定
};

})();
